<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter"><em class="i"><strong class="b">“You can’t deny what’s between us—”</strong></em></div>
<div class="p"><span>“There’s nothing between us, Cameron,” Candy hissed savagely. “Nothing except years of betrayal and hate and misery. Do you really think I would be so insanely foolish as to let myself be persuaded to be another Michelle?”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“By that you mean...?” Cameron asked slowly, his voice expressionless.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“Pregnant and abandoned.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“Was that Michelle’s version of the story?”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“You used her, Cameron, and then walked away when things got too hot. I shall never forgive you. Never.”</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459263314_fm01.vue?298f6c2e